<!-- 公司图片 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <FormItem label="长宽比例">
                            <Select v-model="newFormData.content.height_id" clearable filterable placeholder="请输入长宽比例">
                                <Option v-for="item in heightList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                        <div class="form-title">图片样式</div>
                        <FormItem label="图片样式">
                            <RadioGroup v-model="newFormData.content.autoplay">
                                <Radio label="1">轮播</Radio>
                                <Radio label="0">平铺</Radio>
                            </RadioGroup>
                        </FormItem>
                        <template v-if="newFormData.content.autoplay == 1">
                            <div class="form-title">轮播指示器</div>
                            <FormItem label="指示器"><ColorPicker v-model="newFormData.content.indicator_color"/></FormItem>
                        </template>
                        <template v-if="newFormData.content.autoplay == 0">
                            <div class="form-title">平铺样式</div>
                            <div class="div1" >
                                <div class="div2" v-for="(item, index) in flatStyleList" :key="index" :class=" newFormData.content.style_id == index ? 'style-active' : 'style-default' "
                                    @click="changeImgStyle(index, item)"
                                >
                                    <img class="w80" :src="item.img"/>
                                </div>
                            </div>
                        </template>
                        <div class="form-title mt-24">背景设置</div>
                        <FormItem label="背景颜色"><ColorPicker v-model="newFormData.content.bg_color"/></FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData" label-position="left" :label-width="80">
                        <div class="form-title">组件间距</div>
                        <FormItem label="上下间距"><Slider class="w300" v-model="newFormData.content.marginData.top"></Slider></FormItem>
                        <FormItem label="左右间距"><Slider class="w300" v-model="newFormData.content.marginData.left"></Slider></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"><Slider class="w300" v-model=" newFormData.content.marginData.topRadius"></Slider></FormItem>
                        <FormItem label="下圆角"><Slider class="w300" v-model=" newFormData.content.marginData.bottomRadius"></Slider></FormItem>
                    </Form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            name_id: "1",
            heightList: [
                { id: 1, name: "1：1" },
                { id: 2, name: "2：1" },
                { id: 3, name: "4：3" },
                { id: 4, name: "3：4" },
                { id: 5, name: "1：2" },
            ],
            flatStyleList: [
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile1.png", num: 1 },
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile2.png", num: 2 },
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile3.png", num: 3 },
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile4.png", num: 4 },
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile5.png", num: 5 },
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile6.png", num: 6 },
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile7.png", num: 7 },
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile8.png", num: 8 },
                { img: "https://suyuan.hulianzaowu.com/icon/diys/tile9.png", num: 9 },
            ],
        };
    },
    mounted() {
    },
    methods: {
        selectName(name) {
            this.name_id = name;
        },
        changeImgStyle(index, item) {
            this.newFormData.content.style_id = index;
            var num = item.num - this.newFormData.content.imgList.length;
            for (let i = 0; i < num; i++) {
                this.newFormData.content.imgList.push({
                    value: "/icon/diys/banner.png", picview: "https://suyuan.hulianzaowu.com/icon/diys/banner.png",
                });
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.style-active {
    border: 1px solid #fe761d;
    color: #fe761d;
}
.style-default {
    border: 1px solid #dadada;
    color: #333333;
}
.div1 {
    padding: 12px 0 0 12px;
    width: 80%;
    border: 1px solid #dadada;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.div2 {
    margin: 0 12px 12px 0;
    width: 100px;
    height: 100px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.w80 {
    width: 80px;
}
</style>